// All static images used by Configure layers. Image source files live under src/pages/pannel/editor/images/
// (two levels up from this file).
import img_vastu_numbers_81                    from '../../images/vastu-numbers-81.png';
import img_grid_3x3                            from '../../images/3x3.png';
import img_floor_plan_vpm                      from '../../images/floor-plan-vpm.png';
import img_shakti_chakra                       from '../../images/shakti-chakra.png';
import img_mahavastu_chakra                    from '../../images/mahavastu-chakra.png';
import img_Vedic_mahavastu_chakra              from '../../images/vadic-mahavastu-chakra.png';
import img_modern_Devata_45                    from '../../images/45-devta-1.png';
import img_marmsthan_analysis                  from '../../images/marmsthan-analysis.png';
import img_vastu_numbers_64                    from '../../images/modern-vastu-numbers-64.png';
import img_vastu_numbers_81_numbers            from '../../images/modern-vastu-numbers-with-devta-81.png';
import img_vastu_numbers_81_numbers_Vedic      from '../../images/modern-vastu-numbers-with-devta-81-vadic.png';
import img_shakti_chakra_2                     from '../../images/shakti-chakra-2-1.png';
import img_nakshatra_vastu                     from '../../images/img_nakshatra_vastu.png';
import img_devata_nakshatra_vastu              from '../../images/devta-nakshatra-vastu.png';
import img_32_entrance_analysis_compass        from '../../images/32-entrance-analysis-compass.png';
import img_16_directional                      from '../../images/16-directional-domestic-vastu.png';
import img_direction_diety_planet              from '../../images/direction-diety-planet.png';
import img_devata_khanij                       from '../../images/devata-khanij.png';
import img_devata_bhojan                       from '../../images/devata-bhojan.png';
import img_devata_bhojan_aadi                  from '../../images/devata-bhojan-aadi.png';
import img_devata_chinha                       from '../../images/devata-chinha.png';
import img_devata_chinha_aadi                  from '../../images/devata-chinha-aadi.png';
import img_muhurat_vichar                      from '../../images/muhurat-vichar.png';
import img_seharumkh                           from '../../images/seharumkh-achintya-vibhav.png';
import img_disha_gandha                        from '../../images/disha-gandha.png';
import img_devata_nighat                       from '../../images/devata-nighat.png';
import img_nighantu                            from '../../images/nighantu.png';
import img_Vedic_devata_numbers_81             from '../../images/vedic-devata-numbers-with-names-81.png';
import img_khanija_dhatu                       from '../../images/khanija-dhatu.png';
import img_cover_logo                          from '../../images/shakti-chakra-2-1.png';
import img_cover_page_template                 from '../../images/cover-page-template.jpg';
import img_last_page_template                  from '../../images/last-page-template.jpg';
import img_house_bank                          from '../../images/house-bank.png';
import img_house_clinic                        from '../../images/house-clinic.png';
import img_house_electronic_shop               from '../../images/house-electronic-shop.png';
import img_house_factory                       from '../../images/house-factory.png';
import img_house_hotel                         from '../../images/house-hotel.png';
import img_house_marriage_hall                 from '../../images/house-marriage-hall.png';
import img_house_multiplex                     from '../../images/house-multiplex.png';
import img_house_office_cabin                  from '../../images/house-office-cabin.png';
import img_house_petrol_pump                   from '../../images/house-petrol-pump.png';
import img_house_retail_outlets                from '../../images/house-retail-outlets.png';
import img_house_school_college                from '../../images/house-school-college.png';
import img_house_space_analysis_compass        from '../../images/house-space-analysis-compass.png';
import img_house_temple                        from '../../images/house-temple.png';

export {
  img_vastu_numbers_81,
  img_grid_3x3,
  img_floor_plan_vpm,
  img_shakti_chakra,
  img_mahavastu_chakra,
  img_Vedic_mahavastu_chakra,
  img_modern_Devata_45,
  img_marmsthan_analysis,
  img_vastu_numbers_64,
  img_vastu_numbers_81_numbers,
  img_vastu_numbers_81_numbers_Vedic,
  img_shakti_chakra_2,
  img_nakshatra_vastu,
  img_devata_nakshatra_vastu,
  img_32_entrance_analysis_compass,
  img_16_directional,
  img_direction_diety_planet,
  img_devata_khanij,
  img_devata_bhojan,
  img_devata_bhojan_aadi,
  img_devata_chinha,
  img_devata_chinha_aadi,
  img_muhurat_vichar,
  img_seharumkh,
  img_disha_gandha,
  img_devata_nighat,
  img_nighantu,
  img_Vedic_devata_numbers_81,
  img_khanija_dhatu,
  img_cover_logo,
  img_cover_page_template,
  img_last_page_template,
  img_house_bank,
  img_house_clinic,
  img_house_electronic_shop,
  img_house_factory,
  img_house_hotel,
  img_house_marriage_hall,
  img_house_multiplex,
  img_house_office_cabin,
  img_house_petrol_pump,
  img_house_retail_outlets,
  img_house_school_college,
  img_house_space_analysis_compass,
  img_house_temple,
};

export const predefinedImages = {
  'vastu-numbers-81':                   img_vastu_numbers_81,
  'grid-3x3':                           img_grid_3x3,
  'floor-plan-vpm':                     img_floor_plan_vpm,
  'shakti-chakra':                      img_shakti_chakra,
  'mahavastu-chakra':                   img_mahavastu_chakra,
  'Vedic-Mahavastu-Chakra':             img_Vedic_mahavastu_chakra,
  'modern-Devata-45':                   img_modern_Devata_45,
  'marmsthan-analysis':                 img_marmsthan_analysis,
  'vastu-numbers-64':                   img_vastu_numbers_64,
  'vastu-numbers-81-numbers':           img_vastu_numbers_81_numbers,
  'vastu-numbers-81-numbers-Vedic':     img_vastu_numbers_81_numbers_Vedic,
  'png-image-1':                        img_shakti_chakra_2,
  'nakshatra-vastu':                    img_nakshatra_vastu,
  'Devata-Nakshatra-Vastu':             img_devata_nakshatra_vastu,
  '32-Entrance-Analysis-Compass':       img_32_entrance_analysis_compass,
  '16-Directional-Domestic-Vastu':      img_16_directional,
  'Direction-Diety-Planet':             img_direction_diety_planet,
  'Devata-Khanij':                      img_devata_khanij,
  'Devata-Bhojan':                      img_devata_bhojan,
  'Devata-Bhojan-aadi':                 img_devata_bhojan_aadi,
  'Devata-chinha':                      img_devata_chinha,
  'Devata-chinha-aadi':                 img_devata_chinha_aadi,
  'Muhurat-vichar':                     img_muhurat_vichar,
  'Seharumkh-achintya-vibhav':          img_seharumkh,
  'png-image-2':                        img_shakti_chakra_2,
  'Disha-Gandha':                       img_disha_gandha,
  'Devata-Nighat':                      img_devata_nighat,
  'Nighantu':                           img_nighantu,
  'Vedic-devata-Numbers-with-Names-81': img_Vedic_devata_numbers_81,
  'Khanija-Dhatu':                      img_khanija_dhatu,

  // Planning Guide
  'house-bank':                          img_house_bank,
  'house-clinic':                        img_house_clinic,
  'house-electronic-shop':                img_house_electronic_shop,
  'house-factory':                       img_house_factory,
  'house-hotel':                         img_house_hotel,
  'house-marriage-hall':                 img_house_marriage_hall,
  'house-multiplex':                     img_house_multiplex,
  'house-office-cabin':                  img_house_office_cabin,
  'house-petrol-pump':                   img_house_petrol_pump,
  'house-retail-outlets':                img_house_retail_outlets,
  'house-school-college':                img_house_school_college,
  'house-space-analysis-compass':        img_house_space_analysis_compass,
  'house-temple':                        img_house_temple,
};
